import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';
import { RULES_QUERY_KEY } from './rulesQueryKeys';

export const useDeleteRule = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: (_data, variables) => {
      if (!variables.skipInvalidation) {
        queryClient.invalidateQueries([RULES_QUERY_KEY]);
      }
    },
    mutationFn: ({
      deletedRuleId,
    }: {
      deletedRuleId: ID;
      skipInvalidation?: boolean;
    }) => api.request(endpoints.rules.delete(deletedRuleId)),
  });
};
